__turbopack_context__.v({
  "Cont": "FeatureList-module-sass-module__7wEqha__Cont",
  "Copy": "FeatureList-module-sass-module__7wEqha__Copy",
  "Feature": "FeatureList-module-sass-module__7wEqha__Feature",
  "FeatureContent": "FeatureList-module-sass-module__7wEqha__FeatureContent",
  "FeatureCopy": "FeatureList-module-sass-module__7wEqha__FeatureCopy",
  "FeatureList": "FeatureList-module-sass-module__7wEqha__FeatureList",
  "Features": "FeatureList-module-sass-module__7wEqha__Features",
  "HideBottomLine": "FeatureList-module-sass-module__7wEqha__HideBottomLine",
  "Intro": "FeatureList-module-sass-module__7wEqha__Intro",
});
